import { render, staticRenderFns } from "./ListableSettings.vue?vue&type=template&id=37ccac67&scoped=true"
import script from "./ListableSettings.vue?vue&type=script&lang=js"
export * from "./ListableSettings.vue?vue&type=script&lang=js"
import style0 from "./ListableSettings.vue?vue&type=style&index=0&id=37ccac67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ccac67",
  null
  
)

export default component.exports